export default {
      id: "dots-vertical-mono-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#dots-vertical-mono",
      toString: function () {
        return this.url;
      }
    }